import { LucidServerAPI } from '~api/api';

export const getProjectChildren = (projectId) => {
  return LucidServerAPI().get('/projects', {
    params: { filter: `parent_id:eq:${projectId}` }
  });
};

export const getProjectOutputs = (projectId, order) => {
  return LucidServerAPI().get('/outputs', {
    params: {
      filter: `project_id:eq:${projectId}`,
      order,
      count: 100
    }
  });
};

export const getProjectSessions = (projectId) => {
  return LucidServerAPI().get(`/projects/${projectId}/sessions`);
};

export const updateProject = (projectId, project = {}) => LucidServerAPI().patch(`/projects/${projectId}`, project);
